import getBasePath from '@/common/functions/api-resource';
import resourceBuilder from '@/common/functions/metadados-resource-builder';

const basePath = getBasePath('job', 'acompanhamento-campanhas-ads');

export const executarExportacao = (parametros, resource) => resourceBuilder.buildPOST(resource, basePath, 'executar', parametros).doPost(parametros);

export const verificarDadosExportacao = (parametros, resource) => resourceBuilder.buildGET(resource, basePath, 'verificar-dados-exportacao', parametros).doGet();
